import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/bookings": [3],
		"/bookings/changeTransport": [4],
		"/bookings/changeTransport/[id]": [5],
		"/bookings/createFromQueue": [7],
		"/bookings/create": [6],
		"/bookings/details": [8],
		"/bookings/details/[id]": [9],
		"/bookings/parkedOrder": [10],
		"/bookings/parkedOrder/[id]": [11],
		"/bta-import": [12],
		"/calendar": [13],
		"/customers": [14],
		"/customers/upload": [16],
		"/customers/[id]": [15],
		"/dashboard": [17],
		"/inventory/products": [18],
		"/inventory/products/[productId]": [19],
		"/inventory/products/[productId]/inventoryHistory/[inventoryId]": [20],
		"/inventory/statuses": [21],
		"/reports": [22],
		"/runsheet/general": [23],
		"/runsheet/missing": [24],
		"/runsheet/qa": [25],
		"/runsheet/shipping": [26],
		"/self_onboard": [27],
		"/settings/access-management": [28],
		"/settings/postal-code-settings": [29],
		"/settings/profile": [30],
		"/settings/stylists": [31],
		"/settings/sync-status": [32],
		"/user/change_password": [33],
		"/user/login": [34],
		"/user/logout": [35],
		"/version": [36],
		"/widgets": [37]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';